import { request } from 'src/api/request';
import {
  CreateProviderCohortData,
  UpdateProviderCohortData,
  CreateProviderCohortResponse,
} from 'src/api/redux/providerCohorts';

/**
 * Fetches a list of provider cohorts.
 * @param queryParams - String containing query parameters (e.g., '?page=1&page_size=10')
 */
export const getProviderCohorts = async (queryParams = '') => {
  return await request({
    url: `v1/search/provider-cohorts/${queryParams}`,
    method: 'GET',
  });
};

/**
 * Fetches a specific provider cohort by its ID.
 * @param id - The ID of the cohort to fetch.
 */
export const getProviderCohortById = async (id: string) => {
  return await request({
    url: `v1/search/provider-cohorts/${id}/`,
    method: 'GET',
  });
};

/**
 * Creates a new provider cohort.
 * @param data - The data for the new cohort (label, scope, cohort_language).
 */
export const createProviderCohort = async (
  data: CreateProviderCohortData
): Promise<CreateProviderCohortResponse> => {
  return await request({
    url: `v1/search/provider-cohorts/`,
    method: 'POST',
    data,
  });
};

/**
 * Updates an existing provider cohort. Currently only supports updating the label.
 * @param id - The ID of the cohort to update.
 * @param data - The update data (currently just { label: string }).
 */
export const updateProviderCohort = async (
  id: string,
  data: UpdateProviderCohortData
) => {
  return await request({
    url: `v1/search/provider-cohorts/${id}/`,
    method: 'PATCH',
    data,
  });
};

/**
 * Deletes a provider cohort.
 * @param id - The ID of the cohort to delete.
 */
export const deleteProviderCohort = async (id: string) => {
  return await request({
    url: `v1/search/provider-cohorts/${id}/`,
    method: 'DELETE',
  });
};
